import { TbStar } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const StarIcon = (props: IconProps) => {
  return <IconBase icon={TbStar} {...props} />;
};
